import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  AppBar,
  Toolbar,
  Drawer,
  IconButton,
  Box,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import Search from "@mui/icons-material/Search";
import Close from "@mui/icons-material/Close";
import { fetchSortedPosts } from "../services/searchService";

const StyledOutlinedInput = styled("input")(({ theme }) => ({
  padding: theme.spacing(1),
  border: "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: "4px",
  width: "100%",
  fontSize: "1rem",
  "&:focus": {
    outline: "none",
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
}));

export default function SearchAppBar({ status, handleChange, SearchData, fetchData, currentPage }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchValues, setSearchValues] = useState({
    user_name: "",
    keyword: "",
    start_from: "",
    end_till: "",
  });


  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
  };

  const fields = [
    {
      id: "user_name",
      label: "Username",
      placeholder: "Search by username",
      type: "text",
    },
    {
      id: "keyword",
      label: "Keyword",
      placeholder: "Search by keyword",
      type: "text",
    },
    { id: "start_from", label: "Start From", placeholder: "", type: "date" },
    { id: "till_date", label: "End till", placeholder: "", type: "date" },
  ];

  const handleSearchValueChange = (field, value) => {
    setSearchValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleSearch = async (page = 1) => {
    try {
      const searchFields = Object.keys(searchValues).filter(
        (field) => searchValues[field].trim() !== ""
      );

      if (searchFields.length === 0) return;
      const formattedValues = {
        ...searchValues,
        start_from: searchValues.start_from ? formatDate(searchValues.start_from) : "",
        till_date: searchValues.till_date ? formatDate(searchValues.till_date) : ""
      };

      const data = await fetchSortedPosts(searchFields, formattedValues, page);
      SearchData(data);
     // console.log("Search results:", data);
    } catch (error) {
      console.error("Search failed:", error);
    }
  };


  useEffect(() => {
    // Only trigger search if we have search values and it's not the initial load
    const hasSearchValues = Object.values(searchValues).some(value => value.trim() !== "");
     if (hasSearchValues) {
    handleSearch(currentPage);
  }
  }, [currentPage]);


  return (
    <>
      <AppBar position="static" elevation={0} sx={{ backgroundColor: "background.paper" }}>
        <Toolbar>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <FormControl fullWidth variant="outlined" size="small"
              sx={{ maxWidth: 200 }}>
              <Select
                id="select"
                value={status}
                onChange={(e) => handleChange(e.target.value)}
              >
                <MenuItem value={3}>All Posts</MenuItem>
                <MenuItem value={0}>Unreviewed Posts</MenuItem>
                <MenuItem value={2}>Reviewed Posts</MenuItem>
                <MenuItem value={1}>Blocked Posts</MenuItem>

              </Select>
            </FormControl>

            <IconButton onClick={() => setDrawerOpen(true)}>
              <Search fontSize="medium" />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          zIndex: 1300, // Ensure it appears above other elements
          "& .MuiDrawer-paper": {
            width: "100%",
            maxWidth: 280,
            borderRadius: 0,
          },
        }
        }
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        variant="temporary"
        transitionDuration={300}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
          <Typography variant="h6">
            Search Posts
          </Typography>
          <IconButton edge="end" color="inherit" onClick={() => setDrawerOpen(false)}>
            <Close />
          </IconButton>
        </Box>
        <Divider />



        {/* add clear button to clear search values */}
        {(searchValues.user_name || searchValues.keyword || searchValues.start_from || searchValues.till_date) && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', }}>
            <Button
              variant="text"
              sx={{ textTransform: "none", mr: 2 }}
              onClick={() => {
                setSearchValues({
                  user_name: "",
                  keyword: "",
                  start_from: "",
                  till_date: "",
                });
                SearchData(null);
                fetchData();
              }}
            >
              Clear Search
            </Button>
          </Box>
        )}

        <Grid container spacing={2} px={2}>
          {fields.map((field, index) => (
            <Grid size={12} key={index}>
              <label htmlFor={field.id}>{field.label}</label>
              <StyledOutlinedInput
                id={field.id}
                type={field.type}
                placeholder={field.placeholder}
                value={searchValues[field.id]}
                onChange={(e) =>
                  handleSearchValueChange(field.id, e.target.value)
                }
              />
            </Grid>
          ))}
          <Grid size={12}>
            <Button
              disableElevation
              sx={{ textTransform: "none" }}
              fullWidth
              disabled={
                !Object.values(searchValues).some((value) => value.trim() !== "")
              }
              variant="contained"
              onClick={() => {
                handleSearch(1);
                setDrawerOpen(false);
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>


      </Drawer>
    </>
  );
}
